// extracted by mini-css-extract-plugin
export var headingStyle = "search_instant_dropdown_results_list-module--headingStyle--m707j";
export var hitsStyle = "search_instant_dropdown_results_list-module--hitsStyle--8GFhA";